import get from 'lodash/get';
import CustomError from '../utils/CustomError';

export const handleError = (response, callback = null) => {
  console.log('error!', response.data)
  const errcode = get(response, 'data.status.errcode', null);
  const errmsg = get(response, 'data.status.errmsg', null)
  if (errcode > 0) {
    if (callback) callback(false, errcode);
    throw new CustomError(errcode, errmsg);
  } else {
    if (callback) callback(true);
  }
  return;
};



// WEBPACK FOOTER //
// ./src/utils/errorHelper.js